import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { CreateRedirectRequest } from "@shopexperts/shared";

export function useCreateRedirect() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: (data: CreateRedirectRequest) => 
      api.admin.redirects.create({ body: data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'redirects'] });
      toaster.create({
        title: "Redirect created successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useCreateRedirect] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while creating the redirect.';
      
      toaster.create({
        title: "Failed to create redirect",
        description: errorMessage,
        type: "error",
      });
    },
  });
}

